<template>
  <Button class="assistant-popover-start-button" type="button" outlined size="large" v-tooltip.bottom="tooltipMessage" severity="secondary" @click="$emit('click', $event)">
    <div class="assistant-popover-start-button__content">
      <div class="assistant-popover-start-button__button-inner">
        <i class="pi pi-users"></i><div>Ассистенты<span v-if="avatars.length">:</span></div>
      </div>
      <AvatarGroup v-if="avatars.length">
        <Avatar v-for="avatar in avatars" :image="avatar" shape="circle"/>
      </AvatarGroup>
      <div v-else-if="appState.authorized">
        <Badge value="New" severity="info"></Badge>
      </div>
    </div>
  </Button>
</template>

<script setup>
import Button from 'primevue/button';
import AvatarGroup from 'primevue/avatargroup';
import Avatar from 'primevue/avatar';
import Badge from 'primevue/badge';
import { computed } from 'vue';
import { useReferenceStore } from "@/modules/chat/stores/referenceStore";
import { useChatStore } from "@/modules/chat/stores/chatStore";
import {useAppStateStore} from "@/modules/chat/stores/appStore";

const reference = useReferenceStore();
const chatState = useChatStore();
const appState = useAppStateStore();

defineEmits(['click']);

const avatars = computed(() =>
    chatState.assistants.map(assistant =>
        reference.assistants.find(
            referenceAssistant => referenceAssistant.id === assistant.assistant_id
        ).icon
    )
);

const tooltipMessage = computed(() => {
  const result = 'Ассистенты диалога';
  const names = chatState.assistants.map(assistant => reference.assistants.find(referenceAssistant => referenceAssistant.id === assistant.assistant_id).name);
  return names.length ? `${result}: ${names.join(', ')}` : result;
});
</script>
